import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AdminService } from 'src/app/services/admin.service';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService = this.injector.get(AuthService);
    const adminService = this.injector.get(AdminService);
    const router = this.injector.get(Router);

    let service: AdminService | AuthService;
    if(!authService.accessToken && !adminService.accessToken && router.url.includes('admin')){
      // for login page
      service = router.url.includes('admin') ? adminService : authService;
    } else {
      // for other pages
      service = adminService.accessToken ? adminService : authService;
    }
    
    const accessToken = service.accessToken;
    const encryptedCompanyId = authService.getEncryptedCompanyId();
    const headers: Record<string, string> = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
    if (encryptedCompanyId) {
      headers['X-Company-Id'] = encryptedCompanyId;
    }
    req = req.clone({
      setHeaders: headers,
      withCredentials: true
    });

    return next.handle(req).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          switch (err.status) {
            case 401:
              if (accessToken && service.refreshToken && !req.url.includes('refresh-token')) {
                return service.getRefreshToken().pipe(
                  switchMap((res: any) => {
                    service.setToken(res.accessToken, res.refreshToken, res.encryptedCompanyId);
                    const refreshedHeaders: Record<string, string> = { Authorization: `Bearer ${res.accessToken}` };
                    const refreshedComId = authService.getEncryptedCompanyId();
                    if (refreshedComId) {
                      refreshedHeaders['X-Company-Id'] = refreshedComId;
                    }
                    req = req.clone({
                      setHeaders: refreshedHeaders
                    });
                    return next.handle(req);
                  }),
                  catchError((err) => {
                    console.error(err);
                    service.logout(false);
                    return throwError(() => err);
                  })
                );
              }
              service.logout(false);
              return throwError(() => err);
            default:
              return throwError(() => err);
          }
        }
        return throwError(() => err);
      })
    );
  }
}
